import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { usePageTitle } from '../app/pageTitle';
import { tokens } from '../app/theme';
import { UsedConfigurations } from './UsedConfigurations';

interface PageHeaderProps {
  title: string;
  /** Reference permission code, shown after the title as the reference does. */
  code?: string;
  actions?: ReactNode;
}

/** Card-style page title bar with optional actions on the right. */
export function PageHeader({ title, code, actions }: PageHeaderProps) {
  // The header tab of the app shell shows the same title.
  usePageTitle(title);
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
        px: 2,
        py: 1,
        mb: 1.5,
        bgcolor: '#fff',
        border: `1px solid ${tokens.border}`,
        borderRadius: 1,
      }}
    >
      <Typography variant="h2" component="h1" sx={{ flexGrow: 1 }}>
        {title}
        {code ? ` (${code})` : ''}
      </Typography>
      {actions ? <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box> : null}
      <UsedConfigurations />
    </Box>
  );
}
